import { useState, useEffect } from "react";
import axios from "axios";
import MyTasks from "./MyTasks";

export default function GiveTask() {
  const [lawyers, setLawyers] = useState([]);
  const [form, setForm] = useState({
    lawyerId: "",
    date: new Date().toISOString().split("T")[0], // default to today
    time: "10:00",
    notes: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch list of lawyers
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/admin`, { withCredentials: true })
      .then((res) => setLawyers(res.data))
      .catch((err) => console.log(err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const token = localStorage.getItem("token");
    if (!token) {
      alert("You must be logged in to book an appointment.");
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/tasks`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      alert("Appointment requested successfully");

      // Reset form
      setForm({
        lawyerId: "",
        date: new Date().toISOString().split("T")[0],
        time: "10:00",
        notes: "",
      });
    } catch (err) {
      console.error(err);
      setError("Failed to request appointment. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex w-full p-4 gap-4">
      {/* Assign Task section */}
      <div className="w-1/2 bg-white shadow rounded p-4">
        <h2 className="text-xl font-semibold mb-4">Assign Task</h2>
  
        {error && <p className="text-red-600 mb-2">{error}</p>}
  
        <form onSubmit={handleSubmit} className="space-y-3">
          <label className="block text-gray-600 mb-1">Select Developers</label>
          <select
            value={form.lawyerId}
            onChange={(e) => setForm({ ...form, lawyerId: e.target.value })}
            className="w-full p-2 border rounded"
            required
          >
            <option value="">Select Developers</option>
            {lawyers.map((lawyer) => (
              <option key={lawyer._id} value={lawyer._id}>
                {lawyer.name}
              </option>
            ))}
          </select>
  
          <label className="block text-gray-600 mb-1">Task</label>
          <textarea
            placeholder="assign task here..."
            className="w-full p-2 border rounded"
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
          />
  
          <label className="block text-gray-600 mb-1">Priority</label>
          <select
            className="w-full p-2 border rounded"
            value={form.priority || ""} // default to empty string if undefined
            onChange={(e) => setForm({ ...form, priority: e.target.value })}
            required
          >
            <option value="">Select</option>
            <option value="High">🔥 High</option>
            <option value="Medium">⚠️ Medium</option>
            <option value="Low">✅ Low</option>
          </select>
  
          <label className="block text-gray-600 mb-1">Complete this before</label>
          <input
            type="date"
            className="w-full p-2 border rounded"
            value={form.date}
            onChange={(e) => setForm({ ...form, date: e.target.value })}
            required
          />
  
          <button
            type="submit"
            disabled={loading}
            className={`bg-blue-600 text-white px-4 py-2 rounded ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Booking..." : "Book"}
          </button>
        </form>
      </div>
  
      {/* Completed Tasks section */}
      <div className="w-1/2">
        <MyTasks />
      </div>
    </div>
  );
  
}
